// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sBKs68FvBS0KEbu4P3oL{padding:0 24px 24px}.AaV0Lt8ExYxy5aVr4t02{justify-content:space-between;align-items:center;width:100%;display:flex}.FMZaOQwtOlsSSgpYsgsu{margin-top:16px;margin-bottom:24px}.heE8C5fxG5QhVYBjzuXE{text-align:center;margin-top:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `sBKs68FvBS0KEbu4P3oL`,
	"switchBtn": `AaV0Lt8ExYxy5aVr4t02`,
	"wrapSwitches": `FMZaOQwtOlsSSgpYsgsu`,
	"contactTime": `heE8C5fxG5QhVYBjzuXE`
};
export default ___CSS_LOADER_EXPORT___;
